<footer style="position: fixed;left: 0;bottom: 0;width: 100%;pointer-events: none; z-index:-1" >
    <div style="display: grid; grid-template-columns: 4fr 140px 1fr; grid-template-rows: 100px 36px;">
        <div style="grid-column: 1;grid-row: 1;text-align: left;padding-top: 60px;padding-left: 20px;">
            &copy; {{ currentYear }} Viewpoint, Inc. All rights reserved. <a style="color: black;pointer-events: auto;" href="https://www.viewpoint.com/legal/privacy-notice">Privacy Notice</a>
        </div>
        <div style="grid-column: 2;grid-row: 1;">
            <img src="/Cache/images/trimble-footer-logo.png" style="height: 80px;display: block;" />
        </div>
        <div style="grid-column: 3;grid-row: 1;"></div>
        <div style="grid-column: 1;grid-row: 2;background-color: #0e416c;"></div>
        <div style="grid-column: 2;grid-row: 2;background-color: #fbad26;"></div>
        <div style="grid-column: 3;grid-row: 2;background-color: #0e416c;"></div>
    </div>
</footer>